import React, {useState} from 'react';
import {IconButton,
    Paper, 
    ButtonBase,
    Typography
}
     from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';


const NotificationDeleteButton = ({
  handleDelete,
  notification,
  type,
  disabled = false,
  notifications

}) => {

    const [showDialog, setShowDialog] = useState(false);  
    const handleCloseDialog = () => {
      setShowDialog(false);
    };


  const handleDeleteAll = () => {
    setShowDialog(false);
    handleDelete();
  }


  const isDisabled = !notifications || notifications.length === 0;


  return (
    <>
      <Paper sx={{
        display: "flex",backgroundColor: "transparent",p:1}}>
      <ButtonBase
disabled={!notifications || notifications.length === 0}
        sx={{   

       
        }}

      >
        <Typography
        onClick={(event) => {
            event.stopPropagation();
            setShowDialog(true);
            }}
          sx={{
        color: isDisabled ? "rgba(145, 158, 171, 0.8)" : "#48768C", fontSize: 12, fontWeight: 600,
          }}
        >
          Delete All Notifications
          </Typography>
      </ButtonBase>
      </Paper>
      <ConfirmDeleteDialog
        open={showDialog}
        onClose={handleCloseDialog}
        confirmHeader="Delete All Notifications"
        confirmMessage="Are you sure you want to delete all notifications?"
        confirmMessageSubText="This action cannot be undone."
        buttonAction={handleDeleteAll}
        confirmButtonText="Delete All"
        accept={false}
        isLoading={false}
        buttonLoadingText="Deleting..."
        />
    </>
  );
};

export default NotificationDeleteButton;